import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_suo",
  "use": "icon-icon_suo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-icon_suo\">\n<style type=\"text/css\">\n\t#icon-icon_suo .st0{fill:#FFFFFF;}\n\t#icon-icon_suo .st1{fill:#040000;}\n\t#icon-icon_suo .st2{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<path d=\"M726.5,424.47V310.74c0-116.97-95.17-212.14-212.14-212.14s-212.14,95.16-212.14,212.14v113.02\n\tc-42.38,5.14-75.22,41.21-75.22,84.97v331.03c0,47.29,38.34,85.63,85.63,85.63h398.74c47.29,0,85.63-38.34,85.63-85.63V508.74\n\tC796.99,466.61,766.57,431.62,726.5,424.47z M514.36,168.61c78.38,0,142.14,63.76,142.14,142.14v112.37H372.22V310.74\n\tC372.22,232.37,435.99,168.61,514.36,168.61z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon_suo.svg
// module id = MoH/
// module chunks = 102